import { render, staticRenderFns } from "./BlowChildCard.vue?vue&type=template&id=2eaa6b9c&scoped=true&"
import script from "./BlowChildCard.vue?vue&type=script&lang=ts&"
export * from "./BlowChildCard.vue?vue&type=script&lang=ts&"
import style0 from "./BlowChildCard.vue?vue&type=style&index=0&id=2eaa6b9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaa6b9c",
  null
  
)

export default component.exports